import React from 'react';
import { twJoin } from '@shared/utils/twMerge';

type DotProps = {
  className?: string;
};
export const Dot = ({ className = '' }: DotProps) => {
  return <span className={twJoin('text-spanishGray mx-1', className)}>•</span>;
};
